import type { WorkflowStatus } from 'utils/status';

export interface LiveInstantBook {
  status: WorkflowStatus;
  error?: string;
}

export type LiveInstantBookState = Readonly<Record<string, LiveInstantBook>>;

export const initialLiveInstantBookState: LiveInstantBookState = {};
